import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkTreeModule } from '@angular/cdk/tree';
import { RouterModule } from '@angular/router';
// Primeng modules
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { PermissionsComponent } from './components/permissions/permissions.component';
import { PermissionsButtonBarComponent } from './components/permissions-button-bar/permissions-button-bar.component';
import { PermissionsTabGroupComponent } from './components/permissions-tab-group/permissions-tab-group.component';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { PermissionsListComponent } from './components/permissions-list/permissions-list.component';
import { TableModule } from 'primeng/table';
import { FullCalendarModule } from '@fullcalendar/angular';
import { PermissionsCalendarComponent } from './components/permissions-calendar/permissions-calendar.component';
import { TagModule } from 'primeng/tag';
import { StepsModule } from 'primeng/steps';
import { CheckboxModule } from 'primeng/checkbox';
import { PermissionEmailDialogComponent } from './components/permission-email-dialog/permission-email.dialog.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { StepperModule } from 'primeng/stepper';
import { PermissionDialogComponent } from './components/permission-dialog/permission.dialog.component';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PermissionInfoDialogComponent } from './components/permission-info-dialog/permission-info.dialog.component';
import { MenuModule } from 'primeng/menu';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PanelModule } from 'primeng/panel';
import { PermissionsListFiltersComponent } from './components/permissions-list/permissions-list-filters/permissions-list-filters.component';

@NgModule({
    declarations: [
        PermissionsComponent,
        PermissionsButtonBarComponent,
        PermissionsTabGroupComponent,
        PermissionsListComponent,
        PermissionsListFiltersComponent,
        PermissionsCalendarComponent,
        PermissionEmailDialogComponent,
        PermissionDialogComponent,
        PermissionInfoDialogComponent
    ],
    imports: [
        AutoCompleteModule,
        BlockUIModule,
        BlockableDivModule,
        ButtonModule,
        CalendarModule,
        CdkTreeModule,
        CheckboxModule,
        CommonModule,
        DropdownModule,
        FileUploadModule,
        FormsModule,
        FullCalendarModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        MenuModule,
        MultiSelectModule,
        PanelModule,
        ProgressSpinnerModule,
        ReactiveFormsModule,
        RouterModule,
        SharedModule,
        StepperModule,
        StepsModule,
        TabViewModule,
        TableModule,
        TagModule,
    ],
    exports: [
        PermissionsComponent
    ]
})
export class PermissionsModule { }
